import { useEffect, useState } from "react";
import { ScrollText, KeyRound, Users2 } from "lucide-react";
import { http } from "../lib/api";
import { InstructionsAdmin } from "../components/sitesops/InstructionsAdmin";
import { KeysAdmin } from "../components/sitesops/KeysAdmin";
import { VisitorsAdmin } from "../components/sitesops/VisitorsAdmin";
import { SearchSelect } from "../components/SearchSelect";

export default function ConsignesCles() {
  const [tab, setTab] = useState("instructions");
  const [sites, setSites] = useState([]);
  const [siteId, setSiteId] = useState("");
  useEffect(() => { http.get("/sites").then((r) => { setSites(r.data); const last = localStorage.getItem("xaltix_consignes_site"); setSiteId(r.data.find((s) => s.id === last)?.id || r.data[0]?.id || ""); }); }, []);
  useEffect(() => { if (siteId) localStorage.setItem("xaltix_consignes_site", siteId); }, [siteId]);
  return (
    <div className="p-4 md:p-8 max-w-[1800px] mx-auto space-y-5" data-testid="consignes-cles-page">
      <div>
        <h1 className="font-display text-4xl font-extrabold tracking-tight">Consignes, clés & visiteurs</h1>
        <p className="text-sm text-slate-600">Consignes permanentes que les agents lisent et confirment, et badges / clés que les agents prêtent et récupèrent sur le site.</p>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <SearchSelect data-testid="consignes-site" value={siteId} onChange={(e) => setSiteId(e.target.value)} className="border border-slate-300 rounded-md px-3 py-2 text-sm bg-white">
          {sites.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </SearchSelect>
        <div className="flex gap-1 border-b border-slate-200">
          {[["instructions", "Consignes", ScrollText], ["keys", "Badges & clés", KeyRound], ["visitors", "Visiteurs", Users2]].map(([k, l, Icon]) => (
            <button key={k} data-testid={`consignes-tab-${k}`} onClick={() => setTab(k)} className={`px-4 py-2 text-sm font-semibold -mb-px border-b-2 inline-flex items-center gap-1.5 transition-colors ${tab === k ? "border-amber-600 text-amber-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}><Icon className="h-3.5 w-3.5" />{l}</button>
          ))}
        </div>
      </div>
      {!siteId ? <div className="text-sm text-slate-500">Aucun site.</div> : tab === "instructions" ? <InstructionsAdmin siteId={siteId} /> : tab === "keys" ? <KeysAdmin siteId={siteId} /> : <VisitorsAdmin siteId={siteId} siteName={sites.find((s) => s.id === siteId)?.name} />}
    </div>
  );
}
